<template>
  <div>
    <div v-for="bet in bets" :key="bet.event">
      <v-divider></v-divider>
      <div class="font-weight-bold caption mx-4 mt-2">{{ bet.name }}</div>
      <div v-for="(market, m) in bet.markets" :key="'market' + m">
        <div
          v-for="(selection, r) in averageBetfunc(market.selections)"
          :key="'selections' + r"
        >
          <div v-if="selection.length">
            <div v-for="(bet, b) in selection" :key="b + bet.horse">
              <div
                v-if="bet.stake && bet.odds && bet.profit"
                class="caption mx-4 mt-1"
              >
                <!-- {{ bet.side }} -  -->
                {{ bet.name }}
              </div>
              <div v-if="bet.stake && bet.odds && bet.profit">
                <v-simple-table tile dense>
                  <template #default>
                    <thead>
                      <tr>
                        <th class="text-left caption font-weight-bold">Odds</th>
                        <th class="text-left caption font-weight-bold">
                          Stake
                        </th>
                        <th class="text-left caption font-weight-bold">
                          Profit/Liability
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        :class="{
                          back: bet.side === 'Back',
                          lay: bet.side === 'Lay'
                        }"
                      >
                        <td class="caption font-weight-bold">
                          <span v-if="bet.betType !== 'bookMaker'">
                            {{ bet.odds | currencyFormat(3) }}
                          </span>
                          <span v-if="bet.betType === 'bookMaker'">
                            {{ ((bet.odds - 1) * 100) | currencyFormat(3) }}
                          </span>
                        </td>
                        <td class="caption font-weight-bold">
                          {{ bet.stake | currencyFormat(0) }}
                        </td>
                        <td class="caption font-weight-bold">
                          <span
                            v-if="
                              bet.betType !== 'bookMaker' &&
                              bet.betType !== 'lineLadder'
                            "
                          >
                            {{
                              calculateWinnings(bet.odds, bet.stake)
                                | currencyFormat(0)
                            }}
                          </span>
                          <span v-if="bet.betType === 'bookMaker'">
                            {{
                              calculateWinnings(bet.odds, bet.stake)
                                | currencyFormat(2)
                            }}
                          </span>
                          <span v-if="bet.betType === 'lineLadder'">
                            {{
                              calculateWinnings(bet.betRate, bet.stake)
                                | currencyFormat(2)
                            }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import multiply from 'lodash/multiply'
import subtract from 'lodash/subtract'
import round from 'lodash/round'
export default {
  name: 'AverageBets',
  props: {
    bets: { type: Array, default: () => [], required: true }
  },
  data() {
    return {
      event: {}
    }
  },
  created() {
    if (
      this.bets.length &&
      this.bets[0].betData &&
      this.bets[0].betData.length
    ) {
      this.event = this.bets[0].betData[0]
    }
  },
  methods: {
    calculateWinnings(odds, stake) {
      if (stake > 0 && odds > 0) {
        const m = multiply(parseFloat(odds), parseFloat(stake))
        const s = subtract(m, parseFloat(stake))
        return round(s, 2) / this.getMyRate()
      }
    },
    averageBetfunc(bets) {
      let prepared = []
      bets.forEach((item) => {
        if (item[0].marketType !== 'INNINGS_RUNS') {
          const name = item[0].selectionName
          const marketType = item[0].marketType
          let stake = 0
          let stakeLay = 0
          const odd = []
          const oddLay = []
          let profit = 0
          let profitLay = 0
          // eslint-disable-next-line array-callback-return
          item.map((oneBet, index) => {
            if (oneBet.side === 'Lay') {
              stakeLay = stakeLay + oneBet.stake
              oddLay.push(
                oneBet.marketId.includes('SB')
                  ? (oneBet.price - 1) * 100
                  : oneBet.price
              )
            } else {
              stake = stake + oneBet.stake
              odd.push(
                oneBet.marketId.includes('SB')
                  ? (oneBet.price - 1) * 100
                  : oneBet.price
              )
            }
          })
          // for (let i = 0; i < odd.length; i++){
          //   odd =
          // }
          const averageOdd =
            (odd.reduce((a, b) => a + b, 0) / odd.length).toFixed(2) * 1
          const averageOddLay =
            (oddLay.reduce((a, b) => a + b, 0) / oddLay.length).toFixed(2) * 1

          profit = (stake * averageOdd - stake).toFixed(2) * 1
          profitLay = (stakeLay * averageOddLay - stakeLay).toFixed(2) * 1

          prepared = [
            ...prepared,
            [
              {
                stake,
                odds: averageOdd,
                profit,
                name,
                marketType,
                side: 'Back'
              },
              {
                stake: stakeLay,
                odds: averageOddLay,
                profit: profitLay,
                name,
                marketType,
                side: 'Lay'
              }
            ]
          ]
        } else {
          const inningArr = []
          // eslint-disable-next-line array-callback-return
          item.map((item1) => {
            inningArr.push(item1)
          })
          return inningArr
        }
      })
      return prepared
    }
  }
}
</script>

<style scss>
.back {
  background: var(--v-secondary-base) !important;
}
.lay {
  background: var(--v-accent-base) !important;
}
</style>
